module.exports = __webpack_public_path__ + "static/media/reloj.2f01017b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/MarkCall/reloj.svg
// module id = 1808
// module chunks = 0